class Counter {
	constructor(root) {
		this.root = null;

		if (typeof root === 'string') {
			this.root = document.querySelector(root);
		} else {
			this.root = root;
		}

		if (this.root) {
			this.id = this.root.dataset.id;
			this.type = this.root.dataset.type;
			this.api = this.root.dataset.counter;
		}
	}

	/**
	 * Обновляет счётчики просмотров у публикаций
	 *
	 * @return {*}
	 * @memberof Counter
	 */
	async update() {
		try {
			if (!this.root) return;

			const formData = new FormData();
			formData.append('id', this.id);
			formData.append('type', this.type);

			const response = await fetch(this.api, {
				method: 'POST',
				body: formData,
			});

			if (!response.ok) {
				throw new Error(`Request failed with status ${response.status}`);
			}
		} catch (error) {
			console.warn('Error: ', error);
		}
	}
}

export default Counter;
